import { createSelector } from 'reselect'

const getRoutesSelector = (state) => state.router
const getPathnameFromRouteSelector = (route) => route.location.pathname

export const currentRouteSelector = createSelector(getRoutesSelector, getPathnameFromRouteSelector)
